export default __webpack_public_path__ + "static/media/paloateparo4.1fec11f0.jpg";